<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col>
            <v-card
              class="py-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary darken-2"
              ></v-progress-linear>
              <v-container v-if="!loading">
                <v-row v-if="list.length <= 0">
                  <v-col class="text-center grey--text">
                    <h1 class="py-4">ไม่พบข้อมูล</h1>
                  </v-col>
                </v-row>
                <v-card
                  v-for="(item, index) in list"
                  :key="index"
                  class="pa-2 mb-3"
                  elevation="4"
                >
                  <v-row class="py-1">
                    <v-col
                      cols="12"
                      sm="2"
                      class="pt-0"
                      align="center"
                      justify="center"
                    >
                      <v-img
                        :src="item.cardImgProflie"
                        aspect-ratio="1"
                        max-width="240"
                      />
                    </v-col>
                    <v-col cols="12" sm="10" class="pt-0">
                      <div :class="{ 'px-2': $vuetify.breakpoint.xsOnly }">
                        <div class="font-weight-bold pb-4">
                          รหัสคำขอ : {{ item.reqCardCode }}
                        </div>
                        <div class="pb-2">
                          {{ item[`getCardTypeName${$root.$i18n.locale}`] }}
                        </div>
                        <div class="pb-2">
                          {{
                            item[`middleName${$lang}`]
                              ? item[`prename${$lang}`] +
                                ' ' +
                                item[`firstName${$lang}`] +
                                ' ' +
                                item[`middleName${$lang}`] +
                                ' ' +
                                item[`lastName${$lang}`]
                              : item[`prename${$lang}`] +
                                ' ' +
                                item[`firstName${$lang}`] +
                                ' ' +
                                item[`lastName${$lang}`]
                          }}
                        </div>
                        <div class="pb-4">
                          {{ item[`issueDate${$root.$i18n.locale}`] }}
                        </div>
                      </div>

                      <v-divider />

                      <v-row class="pa-0 ma-0">
                        <v-col cols="6" class="px-0 ma-0">
                          <span :style="'color:' + item.cardStatus.color">
                            {{
                              item.cardStatus[
                                `reqCardStatusFullName${$root.$i18n.locale}`
                              ]
                            }}
                          </span>
                        </v-col>
                        <v-col
                          v-if="item.cardStatus.trreqCardStatusId != 4"
                          cols="6"
                          class="px-0 ma-0 text-right"
                        >
                          <v-btn
                            color="warning"
                            :to="`/ReqCard/req/${item.reqCardCode}/user`"
                            text
                          >
                            ดูข้อมูล
                          </v-btn>
                        </v-col>
                        <v-col
                          v-if="item.cardStatus.trreqCardStatusId == 4"
                          cols="6"
                          class="px-0 ma-0 text-right"
                        >
                          <v-btn
                            @click="
                              onEditReply(
                                item.cardReply.reqCardReplyDetail,
                                item.reqCardCode
                              )
                            "
                            color="success"
                            text
                            >แก้ไขข้อมูล</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="reply.dialog" max-width="720" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">{{ reply.title }}</div>
        <v-divider />

        <div class="pa-4">
          {{ reply.text }}
        </div>
        <div class="text-center pb-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            large
            depressed
            @click="
              $router.push({
                name: 'ReqCardAddEdit',
                query: { isEdit: true, cardcode: reply.cardcode }
              })
            "
          >
            แก้ไขข้อมูล
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="reply.dialog = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      reply: {
        dialog: false,
        title: 'เหตุผลในการตีกลับ',
        text: '',
        cardcode: ''
      },
      loading: false
    }
  },

  computed: {
    title() {
      return 'สถานะการขอทำบัตร'
    }
  },

  async mounted() {
    this.list = await this.apiGetRequestedList()
  },

  methods: {
    onEditReply(reason, cardcode) {
      this.reply.dialog = !this.reply.dialog
      this.reply.cardcode = cardcode
      this.reply.text = reason
    },

    async apiGetRequestedList() {
      this.loading = true
      const payload = {
        guid: this.$route.params.guid
      }
      try {
        const res = await this.$store.dispatch(
          'reqCard/getRequestedList',
          payload
        )
        this.loading = false
        return (
          res.data.data.map(item => {
            item.fullNameEng =
              item.prenameEng + item.firstNameEng + ' ' + item.lastNameEng
            item.fullNameTha =
              item.prenameTha + item.firstNameTha + ' ' + item.lastNameTha
            item.issueDateTha = this.$dateFormatByLang(item.issueDate, {
              format: 'DD MMMM YYYY, HH:mm',
              addUnit: 'Y',
              addValue: '543'
            })
            item.issueDateEng = this.$dateFormat(item.issueDate, {
              format: 'DD MMMM YYYY, HH:mm',
              locale: 'en'
            })
            // console.log(item)

            return item
          }) || []
        )
      } catch (e) {
        this.loading = false
        console.log(e.response || e)
      }
    }
  }
}
</script>
